export default (pValue, notNumber = '', minimumFractionDigits = 2) => {
  if (!pValue || isNaN(pValue)) {
    return notNumber
  }

  const formatter = Intl.NumberFormat('pt-BR', { style: 'decimal', minimumFractionDigits })
  const n = formatter.format(Number(pValue).toFixed(minimumFractionDigits))
  if (n === 'NaN') {
    return notNumber
  }
  return n
}



// WEBPACK FOOTER //
// ./src/components/primitives/helpers/filters/CurrencyBR.js